import PageLoader from '@components/PageLoader';
import React from 'react';
import { useGetUserV1 } from '@services/cd4pe/users';
import { Navigate, Outlet } from 'react-router-dom';
import { getAuthCookie } from '@utils/api/helpers';

const PublicRoute = () => {
  const authCookie = getAuthCookie();
  const {
    data: user,
    isLoading,
    isFetching,
  } = useGetUserV1({ enabled: !!authCookie });

  if (isLoading && isFetching) {
    return <PageLoader />;
  }

  return authCookie && user ? <Navigate replace to="/" /> : <Outlet />;
};

export default PublicRoute;
